import { IDisplayParams } from '../interfaces/IDisplayParams';

// This class defines member display parameters.
// It contains the selected pagination page number, show detail toggle flag and IsReset flag.
export class DisplayParams implements IDisplayParams {
    Page: number = 1;
    ShowDetailFlag: boolean = false;
    IsReset: boolean = true;
}